// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const selectCurrentWorkspaceId = (state: Record<string, any>) =>
  state.ui.currentWorkspaceId as string;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const selectCurrentOrganizationId = (state: Record<string, any>) =>
  state.ui.currentOrganizationId as string;
